import React from "react";
// import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// import { CombinedReducersType } from "@type/index";
import { Button, Drawer, Spacer } from "@common/AggregationComponent";
import OutfitTabFilterDetails from "@common/NewFilter/OutfitTabFilter/FilterDetails";
import { getEcRenewalCompatibility } from "@util/common";

// type NewFilterProps = {
//   visible:boolean;
//
// }
const OutfitTabNewFilter = (props: any) => {
  const { visible, onClose, total } = props;
  const { t } = useTranslation();
  return (
    <div>
      <Drawer
        closeTitle={"close title"}
        closeLabel={getEcRenewalCompatibility() ? " " : t("text_a11y_close")}
        footer={
          <Button
            element="button"
            variant="primary"
            onClick={() => {
              onClose();
            }}
          >
            {t("text_apply_search_filter")}
          </Button>
        }
        isOpen={visible}
        itemCount={`${t("text_image_search_result_number", { total: total })}`}
        onRequestClose={() => {
          onClose();
        }}
        position="start"
        title={t("text_filter")}
        trapFocus
        variant="fullWidth"
        visible
      >
        <OutfitTabFilterDetails {...props} />
        <Spacer element="div" variant="spacing-05" />
      </Drawer>
    </div>
  );
};

export default OutfitTabNewFilter;
